import { forwardRef } from 'react'
import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'
import type { CrmIntegrationMessageDisplay } from '../../types/crm-integration-message.types'
import CrmIntegrationTextChatMessageListItem from './CrmIntegrationTextChatMessageListItem'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationTextChatMessageListProps = {
  messages: CrmIntegrationMessageDisplay[]
  provider: CrmChatProviderKey
  wazzupChannelType?: string | null
  onRetrySend: (clientId: string) => void
  onDeleteMessage?: (messageId: number) => Promise<boolean>
  deletingMessageId?: number | null
  onVideoPlaybackError?: () => void
  onVoicePlaybackError?: () => void
}

const CrmIntegrationTextChatMessageList = forwardRef<
  HTMLUListElement,
  CrmIntegrationTextChatMessageListProps
>(
  (
    {
      messages,
      provider,
      wazzupChannelType = null,
      onRetrySend,
      onDeleteMessage,
      deletingMessageId = null,
      onVideoPlaybackError,
      onVoicePlaybackError,
    },
    ref,
  ) => (
    <ul ref={ref} className={classes.messagesList}>
      {messages.map((message) => (
        <CrmIntegrationTextChatMessageListItem
          key={message.clientId ?? String(message.id)}
          message={message}
          provider={provider}
          wazzupChannelType={wazzupChannelType}
          onRetrySend={onRetrySend}
          onDeleteMessage={onDeleteMessage}
          isDeleting={deletingMessageId === message.id}
          onVideoPlaybackError={onVideoPlaybackError}
          onVoicePlaybackError={onVoicePlaybackError}
        />
      ))}
    </ul>
  ),
)

CrmIntegrationTextChatMessageList.displayName = 'CrmIntegrationTextChatMessageList'

export default CrmIntegrationTextChatMessageList
